import styled from 'styled-components';

import ModalContainer from '../../containers/ModalContainer';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

/**
 * Composición CENTRADA idéntica a PauseSurveillanceRouteModal /
 * ChangePauseCauseModal / ChangeStateModal (feedback usuario 2026-07-14):
 * icono de alerta → título centrado → campos centrados → botones centrados.
 * Los tres modales del ciclo de patrulla (Nuevo tramo → Cambio de sentido →
 * Causa de la parada) comparten el mismo lenguaje visual.
 */
// Cargando canónico (patrón ConfirmTransferModal/DeleteTeamModal): overlay
// Loader absoluto sobre el modal + contenido atenuado mientras isLoading.
export const ModalContainerStyled = styled(ModalContainer)`
  position: relative;
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 40%;
  left: 45%;
  z-index: 1;
`;

export const ContainerForm = styled.form<{ isLoading?: boolean }>`
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2.5rem 6.35rem;
  width: 100%;
  /* Debe caber en una pantalla de 24" con el chrome del navegador
     (feedback usuario 2026-07-14); si aun así no cabe, scroll interno
     en vez de desbordar el viewport. */
  max-height: 92vh;
  overflow-y: auto;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    padding: 1.5rem 2rem;
    gap: 1.25rem;
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
`;

export const Text = styled(Typography)`
  text-align: center;
`;

export const Title = styled(Text)`
  font-size: 2.4rem;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  width: 100%;
`;

/* El PK del cambio de sentido es UN valor corto ("83+900"): no debe ocupar
   todo el ancho del modal. Lo acotamos aquí porque el InputText fuerza
   max-width:100% en tablet/portrait — sin este wrap saldría a ancho completo. */
export const PkFieldWrap = styled.div`
  width: 100%;
  max-width: 17rem;
`;

/* El textarea ocupa TODO el ancho del cuerpo: el Container interno del
   InputTextArea encoge al centro del Section si no se estira explícitamente. */
export const TextAreaWrap = styled.div`
  width: 100%;

  & > div {
    width: 100%;
  }

  /* El min-height por defecto del InputTextArea (21rem) desborda el modal
     en alto; 10rem basta para una nota y sigue siendo redimensionable. */
  & textarea {
    min-height: 6rem;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    /* Botones SIEMPRE en fila (uno al lado del otro), también en tablet/móvil:
       apilarlos en columna alargaba el modal y se cortaba en navegador (sin la
       barra extra de la PWA). En pantallas estrechas comparten el ancho. */
    & > * {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

export const ActionButton = styled(MainButton)`
  min-width: 13.4rem;
  justify-content: center;

  /* Tablet/móvil: botones EN FILA compartiendo ancho (ver ButtonRow). Sin
     bajar este min-width no cabían dos y se apilaban → modal más alto. */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    min-width: 0;
    flex: 1 1 0;
  }
`;
